export var EnabledDimensions = [
    'ground_force_total_left',
    'ground_force_total_right',
];
export var Dimensions = [
    'ground_force_total_left',
    'ground_force_x_left',
    'ground_force_y_left',
    'ground_force_z_left',
    'ground_force_total_right',
    'ground_force_x_right',
    'ground_force_y_right',
    'ground_force_z_right',
    'accel_ground_force_total_left',
    'accel_ground_force_x_left',
    'accel_ground_force_y_left',
    'accel_ground_force_z_left',
    'accel_ground_force_total_right',
    'accel_ground_force_x_right',
    'accel_ground_force_y_right',
    'accel_ground_force_z_right',
    'sacral_force_total',
    'sacral_force_x',
    'sacral_force_y',
    'sacral_force_z',
    'sacral_momentmodel_total',
    'sacral_momentmodel_x',
    'sacral_momentmodel_y',
    'sacral_momentmodel_z',
    'sacral_moment_sagital',
    'sacral_moment_coronal',
    'sacral_moment_transverse',
    'sacral_angle_sagital',
    'sacral_angle_coronal',
    'sacral_angle_transverse',
    'hip_force_total_left',
    'hip_force_x_left',
    'hip_force_y_left',
    'hip_force_z_left',
    'hip_momentmodel_total_left',
    'hip_momentmodel_x_left',
    'hip_momentmodel_y_left',
    'hip_momentmodel_z_left',
    'hip_moment_sagital_left',
    'hip_moment_coronal_left',
    'hip_moment_transverse_left',
    'hip_angle_sagital_left',
    'hip_angle_coronal_left',
    'hip_angle_transverse_left',
    'hip_force_total_right',
    'hip_force_x_right',
    'hip_force_y_right',
    'hip_force_z_right',
    'hip_momentmodel_total_right',
    'hip_momentmodel_x_right',
    'hip_momentmodel_y_right',
    'hip_momentmodel_z_right',
    'hip_moment_sagital_right',
    'hip_moment_coronal_right',
    'hip_moment_transverse_right',
    'hip_angle_sagital_right',
    'hip_angle_coronal_right',
    'hip_angle_transverse_right',
    'knee_force_total_left',
    'knee_force_x_left',
    'knee_force_y_left',
    'knee_force_z_left',
    'knee_momentmodel_total_left',
    'knee_momentmodel_x_left',
    'knee_momentmodel_y_left',
    'knee_momentmodel_z_left',
    'knee_moment_sagital_left',
    'knee_moment_coronal_left',
    'knee_moment_transverse_left',
    'knee_angle_sagital_left',
    'knee_angle_coronal_left',
    'knee_angle_transverse_left',
    'knee_force_total_right',
    'knee_force_x_right',
    'knee_force_y_right',
    'knee_force_z_right',
    'knee_momentmodel_total_right',
    'knee_momentmodel_x_right',
    'knee_momentmodel_y_right',
    'knee_momentmodel_z_right',
    'knee_moment_sagital_right',
    'knee_moment_coronal_right',
    'knee_moment_transverse_right',
    'knee_angle_sagital_right',
    'knee_angle_coronal_right',
    'knee_angle_transverse_right',
    'com_point_x',
    'com_point_y',
    'com_point_z',
];
//# sourceMappingURL=timeseries-dims.js.map